export default "__VITE_ASSET__CbVJLwYr__"